var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelWebModulesSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 12,
  viewBox: "0 0 14 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13 0a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm-1 6H2v4h10zm0-4H2v3h10zM7.5 3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1m-2 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"
})));
export default SvgChannelWebModulesSm;